export default "__VITE_ASSET__Az6h7KTQ__"